import type { SvgComponent } from '@/types/react-components';

export const PlayIcon = ({ ...props }: SvgComponent) => (
  <svg
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.18945 3.08593V12.9145C4.18945 13.6632 5.01601 14.1169 5.64803 13.7154L13.3699 8.80162C13.9563 8.42867 13.9563 7.57365 13.3699 7.2007L5.64803 2.28499C5.01601 1.88262 4.18945 2.33718 4.18945 3.08593Z"
      fill="#32243C"
    />
  </svg>
);
